export const GET_PROVINCE_LIST = 'PROVINCE/get_province_list';
export const GET_SELECTED_PROVINCE =
  'PROVINCE/GET_SELECTED_PROVINCE';

export const GET_MUNICIPALITIES = 'MUNICIPALITY/get_municipality_list';

export const GET_REGION = 'REGION/get_region';

export const FORM_DATA = {
  name: '',
  description: '',
};

export const FORM_DATA_NATURE_BUSINESS = {
  code: '',
  name: '',
  description: '',
};
